import Environment from '@polleverywhere/core/lib/models/environment'
import URI from 'urijs'

const env = new Environment()

function hostFromUrl (url) {
  return URI(url).absoluteTo(window?.location?.href || '/').host()
}

class TokenStore {
  cache = {}

  has (url) {
    return !!this.cache[hostFromUrl(url)]
  }

  get (url) {
    return this.cache[hostFromUrl(url)]
  }

  set (url, token) {
    this.cache[hostFromUrl(url)] = token
    return token
  }

  reset () {
    this.cache = {}
  }

  /*
  * True if the given URL should have the X-CSRF-Token header set
  */
  expectedFor (url) {
    // Assume we expect a token if we have already received on for this host
    if (this.has(url)) { return true }

    const host = hostFromUrl(url)
    const whitelist = [env.get('api_url'), env.get('root_url'), URI(window?.location?.href)]
    return whitelist.find(uri => uri.host() === host)
  }
}

const tokenStore = new TokenStore()

export default tokenStore
